import { jwtDecode } from 'jwt-decode';

/**
 * True while the stored access token is a 2FA user's password-only sign-in token: the API refuses it
 * on 2FA-guarded routes (e.g. GET /auth/me) until POST /2fa/authenticate succeeds.
 */
export const isTwoFactorPending = token => {
    try {
        const claims = jwtDecode(token);
        return Boolean(claims.isTwoFactorEnable && !claims.isTwoFactorAuthenticated);
    } catch (error) {
        return false;
    }
};
